import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('errors.pageNotFound', 'Page Not Found')} - tvia.ai</title>
        <meta name="description" content={t('errors.pageNotFoundDescription', 'The page you are looking for could not be found.')} />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <div>
            <h1 className="text-9xl font-bold text-cyan-600">404</h1>
            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
              {t('errors.pageNotFound', 'Page Not Found')}
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              {t('errors.pageNotFoundMessage', 'Sorry, we couldn\'t find the page you\'re looking for.')}
            </p>
          </div>

          <div className="mt-8 space-y-4">
            <Link
              to="/"
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
            >
              <HomeIcon className="h-5 w-5 mr-2" />
              {t('navigation.home', 'Home')}
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
            >
              <ArrowLeftIcon className="h-5 w-5 mr-2" />
              {t('common.goBack', 'Go Back')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage; 